<template>
    <div class="l-container">
        <div class="inner">
            <div class="leftSide">
                <img class="logo" v-if="appId == 'wx61625ef299496a43'" src="../assets/huotoupiao-logo.png" alt="">
                <img class="logo" v-if="appId == 'wx3a4ad3501b4d2736'" src="../assets/guanjia-login-logo.png" alt="">
                <img class="logo" v-if="appId == 'wx0bca1de68ed28229'" src="../assets/tp100-login-logo.png" alt="">
                <img class="logo" v-if="appId == 'wxf390d97b8dc86b13'" src="../assets/kutoup-login-logo.png" alt="">
                <img class="logo" v-if="appId == 'wxfd39b0c4f1041eec'" src="../assets/l-logo1.png" alt="">
                <div class="title">
                    {{ name }}
                </div>
                <div class="ewm">
                    <img :src="ewmUrl" alt="">
                    <p>扫码进入投票活动</p>
                </div>
            </div>
            <div class="rightSide">
                <div class="bigT">数据大屏登录</div>
                <input class="ipt1" type="text" placeholder="输入访问密码" v-model="passWord">
                <div class="dlBtn" @click="loginFun">登 录</div>
            </div>
        </div>
        <div class="mask" v-show="maskShow">
            <div class="m-inner">
                <img src="../assets/bd-closeBtn-pop.png" alt="">
                <div class="m-title">登录提示</div>
                <div class="text">该数据大屏已在<span>{{ location }}</span>另一个设备显示，请在手机端将其下线，或联系客服增加登录点数。</div>
                <div class="zdl">知道啦</div>
            </div>
        </div>
    </div>
</template>

 <script>
    import instance from '../api/http.js';
    export default {
        name: "login",
        data(){
            return{
                maskShow: false,
                passWord: '',
                location: '--',
                alias: '',
                appId: '',
                name: '',
                ewmUrl: '',
            }
        },
        async mounted(){
            localStorage.removeItem('largeScreenToken');
            // localStorage.removeItem('alias');
           
        },
        beforeDestroy() {
         
        },
        
       async created() {
        await this.init()
        //     console.log(res,'res')
            if(localStorage.getItem('alias')!=null){
                setTimeout(() => {
                    this.getInformation()
                }, 200);
            }
        },
        methods:{
            async init(){
                console.log('22222')
                return new Promise((resolve) => {
                //获取url参数
                var url = location.href; //获取url中"?"符后的字串
                console.log(url, 'url123')
                if (url.indexOf("?") != -1) { //判断是否有参数
                    let urlStr = url.split('?')[1]
                    let obj = {};
                    let paramsArr = urlStr.split('&')
                    for (let i = 0, len = paramsArr.length; i < len; i++) {
                        let arr = paramsArr[i].split('=')
                        obj[arr[0]] = arr[1];
                    }
                    this.alias = obj.alias
                    localStorage.setItem('alias',this.alias);
                   
                }
					resolve(this.alias)
				})
            },
            loginFun(){
                if (this.passWord == ''){
                    this.$message.error('请输入访问密码');
                    return false;
                }
                this.fetchData();
            },
            fetchData() {
                
                var params = {
                    passWord: this.passWord,
                    alias:this.alias
                };
 
            var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');

                instance.post('largeScreen/largeScreenLogin?'+queryString, {})
                    .then(response => {
                        // 处理响应
                        console.log(response)
                        if (response.data.status == 1){
                            console.log(response.data.data,'response.data.data')
                            localStorage.setItem('largeScreenToken', response.data.data);
                            this.$message({
                                message: '登录成功',
                                type: 'success',
                                onClose: ()=> {
                                    
                                    this.$router.push({
                                        path:'/home',
                                        query: {largeScreenToken: response.data.data,alias:this.alias}
                                    })
                                
                                    // todo 跳转到主页

                                }
                            });
                        } else {
                            this.$message.error(response.data.msg)
                            // this.location = response.msg()
                        }
                    })
                    .catch(error => {
                        // 处理错误
                        console.log(error)
                    });

            },
            // 从地址栏获取字段
            getQueryParam(param) {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(param);
            },
            // 获取信息
            getInformation(){
                console.log('33333')
                instance.post('largeScreen/getInformation',{})
                    .then(response => {
                        // 处理响应
                        console.log(response)
                        if (response.data.status == 1){
                            console.log(response,'信息aaaa')
                            this.appId = response.data.data.appId;
                            this.name = response.data.data.name;
                            this.ewmUrl = response.data.data.url;
                            localStorage.setItem('appId', response.data.data.appId);
                            console.log(this.ewmUrl,'this.ewmUrl')
                        }
                    })
                    .catch(error => {
                        // 处理错误
                        console.log(error)
                    });
            },
        },
        
    }
</script>

<style scoped>
    .l-container{
        height: 100%;
        width: 100%;
        background-color: white;
        background: url("../assets/login-bg1-1x.png") center no-repeat;
        background-size: cover;
        position: relative;
    }
    .inner{
        width: 1080px;
        height: 630px;
        background-color: white;
        border-radius: 30px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
    }
    .leftSide{
        width: 450px;
        height: 100%;
        background: linear-gradient(0deg,rgba(229,234,255,0.95) 0%, rgba(255,255,255,0.95) 100%);
        box-sizing: border-box;
        padding: 55px;
    }
    .rightSide{
        width: 630px;
        height: 100%;
        /*background-color: #1A5CD7;*/
        background: url("../assets/l-bg2.png") center no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .logo{
        /* width: 160px; */
        /* height: 30px; */
        transform: scale(0.5);
        transform-origin: left;
    }
    .leftSide .title{
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #000000;
        margin-top: 30px;
        margin-bottom: 30px;
        line-height: 30px;
    }
    .ewm{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .ewm img{
        width: 220px;
        height: 220px;
        background-color: white;
        margin-bottom: 40px;
        border-radius: 50%;
    }
    .ewm p{
        color: #5A6279;
        font-size: 20px;
    }
    .bigT{
        font-size: 30px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        line-height: 100px;
    }
    .rightSide .ipt1{
        width: 458px;
        height: 70px;
        background: #ffffff;
        border: 2px solid #d4e5ff;
        border-radius: 35px;
        padding-left: 50px;
        padding-right: 50px;
        font-size: 22px;
        color: #969696;
        margin-top: 30px;
        margin-bottom: 80px;
    }
    .dlBtn{
        width: 362px;
        height: 55px;
        background: linear-gradient(to right,#081773 0%, #334dc0 100%);
        border-radius: 28px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 55px;
        cursor: pointer;
    }
    .mask{
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        background-color: rgba(0,0,0,0.5);
    }
    .m-inner{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 361px;
        height: 237px;
        background: #ffffff;
        border-radius: 9px;
    }
    .m-title{
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        color: #2b2f36;
        height: 55px;
        border-bottom: 1px solid #E7E7E7;
        line-height: 55px;
    }
    .m-inner img{
        width: 15px;
        height: 15px;
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .m-inner{
        font-size: 16px;
        text-align: left;
        color: #606060;
        line-height: 22px;
    }
    .m-inner .text{
        width: 80%;
        margin: 26px auto;
    }
    .m-inner span{
        color: #5255F7;
    }
    .m-inner .zdl{
        width: 227px;
        height: 39px;
        background: #5255f7;
        border-radius: 26px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        color: #ffffff;
        line-height: 39px;
        margin: 0 auto;
    }
</style>